export const ACTION_TYPE = {
  SOCKET_GET_MESSAGE: 'SOCKET_GET_MESSAGE',
  NEWS: 'NEWS',
  SECURITY_FINANCIAL_DATA: 'SECURITY_FINANCIAL_DATA',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  DETAIL_PRICE_LV2: 'DETAIL_PRICE_LV2',
  TRADE_DISTRIBUTION: 'TRADE_DISTRIBUTION',
  SECURITY_COMPANY_INFO: 'SECURITY_COMPANY_INFO',
  SECURITY_SHARE_CHANGE: 'SECURITY_SHARE_CHANGE',
  SECURITY_DIVIDEND_RECORD: 'SECURITY_DIVIDEND_RECORD',
  HISTORICAL_DATA: 'HISTORICAL_DATA',
  GET_WATCHLIST: 'GET_WATCHLIST',
  SIMPLE_PRICE_INFO: "SIMPLE_PRICE_INFO",
  DETAIL_PRICE_INFO: "DETAIL_PRICE_INFO",
  TOP_RANK: "TOP_RANK",
  DETAIL_INDUSTRY_RANK: "DETAIL_INDUSTRY_RANK",
  SECURITY_FINANCIAL_REPORT: "SECURITY_FINANCIAL_REPORT",
  WARRANT_BULLBEAR: "WARRANT_BULLBEAR",
  INDEX_DATA: "INDEX_DATA",
  AGGREGATE_ORDER_BOOK: "AGGREGATE_ORDER_BOOK",
  BEST_BID_ASK: "BEST_BID_ASK",
  BROKER_QUEUE: "BROKER_QUEUE",
  CLOSING_PRICE: "CLOSING_PRICE",
  EQUILIBRIUM_PRICE: "EQUILIBRIUM_PRICE",
  INDEX_DEFINITIO: "INDEX_DEFINITION",
  NOMINAL_PRICE: "NOMINAL_PRICE",
  SECURITY_DEFINITION: "SECURITY_DEFINITION",
  SECURITY_STATUS: "SECURITY_STATUS",
  STATISTICS: "STATISTICS",
  REFERENCE_PRICE: "REFERENCE_PRICE",
  TRADE: "TRADE",
  TRADE_TICKER: "TRADE_TICKER",
  TRADING_SESSION_STATUS: "TRADING_SESSION_STATUS",
  VCM_TRIGGER: "VCM_TRIGGER",
  YIELD: "YIELD",
  GREEK_OPTIONS: 'GREEK_OPTIONS',  //delta、theta、gamma、vega
  STATISTICS: 'STATISTICS',   //查询最新价，最高，最低等  price、volume、turnover 、计算change的last
  BEST_BID_ASK: 'BEST_BID_ASK', //查询最好买入价/最好卖出价 ask volume、ask price、bid volume、bid price
  CLOSING_PRICE: 'CLOSING_PRICE', // 查询收盘价  计算 change(%) 的closingPrice    (last - closingPrice )/last *100%
  IMPLIED_VOLATILITY: 'IMPLIED_VOLATILITY', //vi 引申波幅
  TRADE_LOG: "TRADE_LOG",
  GREY_AGGREGATE_ORDER_BOOK: "AGGREGATE_ORDER_BOOK",
  GREY_BROKER_QUEUE: "BROKER_QUEUE",
  GREY_TRADE_TICKER: "TRADE_TICKER",
  GREY_TRADE_LOG: "TRADE_LOG",
  GREY_SECURITY_DEFINITION: "SECURITY_DEFINITION",
  GREY_STATISTICS: 'STATISTICS',
  GREY_DETAIL_PRICE_INFO: "DETAIL_PRICE_INFO",

}

export const NEWS_TYPE = {
  MAIN_NEWS: 11,
  ANNOUNCEMENT: 12,
  PROFESSIONAL: 13
}

export const DEVICE_TYPE = {
  IOS: 'iOS',
  ANDROID: 'Android'
}

export const MDSMACHINES_NUMER = {
  MDS_9997_PUBSUB: '9997'
}

export const MDS_REQUEST_OUT_TIME = 6000

export const MDS_REQUEST_OUT_CODE = 89